import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import AccreditationDateRange from '../../components/AccreditationDateRange';
import { Button } from 'foundations-components/transitional/components/Button';
import ViewCertificateModal from '../../../certificate/components/ViewCertificateModal';
import { useState } from 'react';
import { parseTrackIdFromExamLink } from '../../../../utils/certificates';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsOnOwnProfile, replacePlaceholderWithPortalId } from './profileUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewAwardButton = ({
  credentialTitle,
  grantedCredentialId,
  trackId,
  onClick = () => {},
  onDownloadCertificateClick = () => {}
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isOnOwnProfile = useIsOnOwnProfile();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: () => {
        setIsOpen(true);
        onClick();
      },
      use: "link",
      children: credentialTitle
    }), isOpen && /*#__PURE__*/_jsx(ViewCertificateModal, {
      grantedCredentialId: grantedCredentialId,
      onCloseClick: () => setIsOpen(false),
      onDownloadCertificateClick: onDownloadCertificateClick,
      showShareButton: isOnOwnProfile,
      trackId: trackId
    })]
  });
};
const CertificateLink = ({
  certificate,
  children
}) => {
  if (certificate) {
    return /*#__PURE__*/_jsx(Link, {
      external: true,
      href: certificate,
      children: children
    });
  }
  return children;
};
const AccreditationItem = ({
  accreditation,
  showCertificateModal
}) => {
  const portalId = PortalIdParser.getPortalIdFromPath();
  const isOnOwnProfile = useIsOnOwnProfile();
  const examLink = accreditation.examLink && portalId ? replacePlaceholderWithPortalId(portalId, accreditation.examLink) : accreditation.examLink;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "400",
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        width: '40px',
        flexShrink: 0
      },
      children: accreditation.badge && /*#__PURE__*/_jsx(Image, {
        alt: "",
        src: accreditation.badge
      })
    }), /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        wordBreak: "break-all",
        children: showCertificateModal ? /*#__PURE__*/_jsx(ViewAwardButton, {
          credentialTitle: accreditation.title,
          grantedCredentialId: parseInt(accreditation.credentialId, 10),
          trackId: parseTrackIdFromExamLink(accreditation.examLink)
        }) : /*#__PURE__*/_jsx(CertificateLink, {
          certificate: accreditation.certificate,
          children: accreditation.title
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(AccreditationDateRange, {
          createdAt: accreditation.createdAt,
          expiresAt: accreditation.expiresAt
        })
      }), isOnOwnProfile && examLink && /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(Link, {
          external: true,
          href: examLink,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "profilePage.AcademyProfile.accreditations.retakeExam"
          })
        })
      })]
    })]
  });
};
export default AccreditationItem;